'use client';

import dynamic from 'next/dynamic';

const CookiesPolicyBanner = dynamic(() => import('../components/CookiesPolicyBanner/CookiesPolicyBanner'), {
  ssr: false,
});
const ReffererDetector = dynamic(() => import('../components/ReffererDetector'), {
  ssr: false,
});
const VisitedPagesTracker = dynamic(() => import('../components/VisitedPagesTracker'), {
  ssr: false,
});
const ClientScripts = dynamic(() => import('../components/ClientScripts'), {
  ssr: false,
});
const UserActivityTracker = dynamic(() => import('../components/UserActivityTracker'), {
  ssr: false,
});

const ClientParts = () => (
  <>
    <ClientScripts />
    <VisitedPagesTracker />
    <CookiesPolicyBanner />
    <ReffererDetector />
    <UserActivityTracker />
  </>
);

export default ClientParts;
